import { render, staticRenderFns } from "./InboxListItem.vue?vue&type=template&id=cc90fbe6&scoped=true&lang=pug"
import script from "./InboxListItem.vue?vue&type=script&lang=js"
export * from "./InboxListItem.vue?vue&type=script&lang=js"
import style0 from "./InboxListItem.vue?vue&type=style&index=0&id=cc90fbe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc90fbe6",
  null
  
)

export default component.exports